import React from 'react';
import HeaderWrapper from '../components/header-wrapper/HeaderWrapper';
import EnvVarsFeaturesContext from './EnvVarsFeaturesContext';
import { UserContextProvider } from '../scaffold/UserContext';

class HeaderApp extends React.Component {
  constructor(props) {
    super();
    const {
      envVars = {},
      features = {},
      categories = {},
      categoryOverrides = {},
      categoryOverridesId = [],
    } = props.initialState;
    this.envVars = envVars;
    this.features = features;
    this.categories = categories;
    this.categoryOverrides = categoryOverrides;
    this.categoryOverridesId = categoryOverridesId;
  }
  render() {
    return (
      <div>
        <UserContextProvider>
          <EnvVarsFeaturesContext.Provider
            value={{
              envVars: this.envVars,
              features: this.features,
              categories: this.categories,
              categoryOverrides: this.categoryOverrides,
              categoryOverridesId: this.categoryOverridesId,
            }}
          >
            <HeaderWrapper
              experiences={this.features.monetateExperiences}
              features={this.features}
            />
          </EnvVarsFeaturesContext.Provider>
        </UserContextProvider>
      </div>
    );
  }
}

HeaderApp.displayName = 'HeaderApp';

export default HeaderApp;
